import ReactOnRails from 'react-on-rails';

import 'packs/global';

import { registerWithErrorBoundary } from 'helpers/react_on_rails';

import AccessChangedBanner from 'components/documents/access_settings/access_changed_banner';
import AiAssistant from 'components/ai/assistant';
import OmniSearch from 'components/omni_search';
import AiSettingsForm from 'components/users/ai_settings/ai_settings_form';
import AnywhereGuidMatcher from 'bundles/company/anywhere_guid_matcher';
import ApexCustomFieldRawInputs from 'bundles/apex/custom_fields/form/raw_inputs';
import ApexPipelineConfig from 'bundles/apex/pipeline/settings/index';
import ApexSettings from 'bundles/apex/settings/class_component';
import AssignmentEditFormWrapper from 'components/assignments/assignment_edit_form';
import AssignmentEditor from 'bundles/assignment/assignment_editor';
import AssignmentIndex from 'bundles/assignment/index/assignment_index';
import AssociatedTasks from 'bundles/tasks/associated_tasks';
import AttachmentsPanel from 'components/attachments/panel';
import BetaProgramForm from 'components/users/beta_program/beta_program_form';
import BillingAccountDetail from 'components/billing/billing_account_detail';
import BioPdfUpload from 'components/users/user_form/bio_pdf_upload';
import BiographyTab from 'components/users/biography/biography_tab';
import BrokerTitles from 'bundles/company/broker_titles/index';
import BulkActionsButton from 'components/documents/bulk_actions_button/index';
import CallContactLink from 'components/click_to_call/call_contact_link';
import CallListIndex from 'bundles/tasks/index/call_list_index';
import ChecklistEditor from 'bundles/checklist_editor/checklist_editor';
import CommissionPlanSettings from 'bundles/backoffice/commission_plans/settings/class_component';
import CompaniesPaginationButtons from 'components/contacts/companies/companies_pagination_buttons';
import CompanyGridsSettings from 'bundles/shadow_grid/company_grids_settings';
import CompanyProfile from 'bundles/company/profile/index';
import CompanyRequiredFields from 'bundles/company/required_fields';
import CompsIndex from 'bundles/comps/index/comps_index';
import CompReportForm from 'bundles/comp_reports/form';
import ConfigurableEnumIndex from 'bundles/company/configurable_enums/index';
import ContactIndex from 'bundles/contact/index/contact_index';
import ContactPreviewContainer from 'components/contacts/contact_preview/contact_preview_container';
import ContactProjectSection from 'bundles/contact/contact_project_section';
import ContactRoleContextMenu from 'components/research/property/contact_info/contact_role_context_menu';
import CorporateDatabases from 'bundles/corporate/corporate_databases';
import CrmIntegrationSettings from 'bundles/crm/integrations/settings';
import CustomFieldsConfig from 'bundles/apex/custom_fields/config';
import DatabaseTagManager from 'bundles/databases/database_settings/database_tag_manager';
import DatabaseFormsWrapper from 'components/database/database_forms';
import DeductionSettings from 'bundles/backoffice/deductions/settings';
import DepartmentUserSelect from 'bundles/company/departments/department_user_select';
import DocTemplateList from 'bundles/company/document_defaults/doc_template_list';
import DocumentAccessSettings from 'components/documents/access_settings/index';
import DocumentDefaults from 'bundles/company/document_defaults/document_defaults';
import DuplicatePropertyButton from 'components/research_property/duplicate_property_button';
import EmailCredentialEdit from 'components/e_mail/email_credential_edit';
import EmailTeams from 'bundles/email/teams';
import EmailNotificationsTab from 'bundles/project/components/email_notifications_tab';
import PropertyEmailIndex from 'bundles/email_index/property_email_index';
import EmailSendLimitWidget from 'bundles/email_send_limit/email_send_limit_widget';
import ForwardingEmail from 'components/forwarding_email';
import ImporterIndex from 'bundles/importer/navigator/importer_index';
import IntegrationsTab from 'components/users/integrations/integrations_tab';
import InventoryReport from 'components/reports/inventory_report/index';
import DownloadableReportFieldSelector from 'components/document_editor/downloadable_report_field_selector';
import InvoiceDefaults from 'bundles/company/invoice_defaults/index';
import InvoicingForm from 'bundles/invoicing_form/index';
import JobTitles from 'bundles/company/job_titles/index';
import JobTitlesSelect from 'bundles/users/profile/job_titles_select';
import LeadsIndex from 'bundles/leads/index/leads_index';
import LimitBrokersOnPlugin from 'bundles/company/plugin_set/limit_brokers_on_plugin';
import LogoVerifyList from 'components/master_logos/logo_verify_list';
import ShowcaseContactsCompanyIndex from 'bundles/showcase_contacts/company_index';
import Snackbar from 'components/ui/snackbar';
import MergeCompanies from 'bundles/contact/index/companies/merge_companies';
import MergePeople from 'bundles/contact/index/people/merge_people';
import MobileNewTaskFormStyleWrapper from 'components/tasks/mobile_new_task_form_style_wrapper';
import MobileActivityFormWrapper from 'components/contacts/forms/mobile_activity_form_wrapper';
import MobileAssociatedTasksWrapper from 'bundles/tasks/mobile_associated_tasks_wrapper';
import NewListingModal from 'bundles/project/components/new_listing_modal';
import Notifications from 'components/notification_preferences/notifications';
import OptionDefaults from 'bundles/email/option_defaults';
import ParentCompanyUserProfile from 'bundles/corporate/parent_company_users/profile';
import PeoplePaginationButtons from 'components/contacts/people/people_pagination_buttons';
import PhotoForm from 'components/photos/photo_form';
import PinnedListings from 'bundles/plugin/pinned_listings';
import PipelineDefaultsEditor from 'bundles/pipeline/defaults_editor';
import PluginSetEditor from 'bundles/plugin/plugin_set_editor/plugin_set_editor';
import PrimaryCompanyButton from 'components/contacts/people/primary_company_button';
import ProfilePhotoUpload from 'components/users/user_form/profile_photo_upload';
import ProjectEditor from 'bundles/project/project_editor';
import PropertiesPaginationButtons from 'components/research_property/properties_pagination_buttons';
import PropertyEditFormWrapper from 'components/property/property_edit_form';
import PermissionsTab from 'components/users/permissions/permissions_tab';
import PurchasesTab from 'components/users/purchases/purchases_tab';
import RentRollTable from 'components/property/rent_roll/rent_roll_table';
import QuickbooksBrokerVendorTable from 'bundles/backoffice/quickbooks/broker_vendor_table';
import QuickbooksUserVendorTable from 'bundles/backoffice/quickbooks/user_vendor_table';
import QuokkaTemplatesInUseSection from 'components/company_settings/quokka_templates_in_use_section';
import RequirementsFormContainer from 'bundles/contact/requirements/requirements_form_container';
import RequirementsPanel from 'bundles/contact/requirements/requirements_panel';
import RequirementsSetIndex from 'bundles/requirements_set/index/requirements_set_index';
import ResearchIndex from 'bundles/research/index/research_index';
import RoyaltySettingsIndex from 'bundles/backoffice/royalty_settings';
import SaleBuyer from 'components/property/sale_buyer';
import SendRepEmailButton from 'bundles/project/components/syndication/send_rep_email_button';
import ShareLink from 'components/documents/share_link';
import SurveyPropertyForm from 'bundles/assignment/components/survey_property_form';
import SwitchAccounts from 'components/users/switch_accounts';
import SyndicationBrokerPartnerTable from 'components/syndication/broker_partner_table';
import SyndicationTab from 'components/users/syndication/syndication_tab';
import Tags from 'bundles/tags/tags';
import TasksIndex from 'bundles/tasks/index/tasks_index';
import TemplateTranslations from 'bundles/template_translations';
import TerritoriesTab from 'bundles/company/territories/index';
import TransferRecordsContainer from 'components/database/transfer_records_container';
import UserProfile from 'bundles/users/profile/index';
import VoucherApprovalWorkflowEditor from 'bundles/backoffice/vouchers/approval_workflow';
import WebhookEventIndex from 'bundles/webhook_event/index/webhook_event_index';
import { StripeAccountSetup } from 'bundles/stripe/account_setup';
import { StripeCustomerSetup } from 'bundles/stripe/customer_setup';

registerWithErrorBoundary({
  AiAssistant,
  OmniSearch,
});

ReactOnRails.register({
  AccessChangedBanner,
  AiSettingsForm,
  AnywhereGuidMatcher,
  ApexCustomFieldRawInputs,
  ApexPipelineConfig,
  ApexSettings,
  AssignmentEditFormWrapper,
  AssignmentEditor,
  AssignmentIndex,
  AssociatedTasks,
  AttachmentsPanel,
  BetaProgramForm,
  BillingAccountDetail,
  BioPdfUpload,
  BiographyTab,
  BrokerTitles,
  BulkActionsButton,
  CallContactLink,
  CallListIndex,
  ChecklistEditor,
  CommissionPlanSettings,
  CompaniesPaginationButtons,
  CompanyGridsSettings,
  CompanyProfile,
  CompanyRequiredFields,
  CompReportForm,
  CompsIndex,
  ConfigurableEnumIndex,
  ContactIndex,
  ContactPreviewContainer,
  ContactProjectSection,
  ContactRoleContextMenu,
  CorporateDatabases,
  CrmIntegrationSettings,
  CustomFieldsConfig,
  DatabaseFormsWrapper,
  DatabaseTagManager,
  DeductionSettings,
  DepartmentUserSelect,
  DocTemplateList,
  DocumentAccessSettings,
  DocumentDefaults,
  DuplicatePropertyButton,
  EmailCredentialEdit,
  EmailTeams,
  EmailNotificationsTab,
  PropertyEmailIndex,
  EmailSendLimitWidget,
  ForwardingEmail,
  ImporterIndex,
  IntegrationsTab,
  InventoryReport,
  DownloadableReportFieldSelector,
  InvoiceDefaults,
  InvoicingForm,
  JobTitles,
  JobTitlesSelect,
  LeadsIndex,
  LimitBrokersOnPlugin,
  LogoVerifyList,
  ShowcaseContactsCompanyIndex,
  MergeCompanies,
  MergePeople,
  MobileNewTaskFormStyleWrapper,
  MobileActivityFormWrapper,
  MobileAssociatedTasksWrapper,
  NewListingModal,
  Notifications,
  OptionDefaults,
  ParentCompanyUserProfile,
  PeoplePaginationButtons,
  PhotoForm,
  PinnedListings,
  PipelineDefaultsEditor,
  PluginSetEditor,
  PrimaryCompanyButton,
  ProfilePhotoUpload,
  ProjectEditor,
  PropertiesPaginationButtons,
  PropertyEditFormWrapper,
  PermissionsTab,
  PurchasesTab,
  QuickbooksBrokerVendorTable,
  QuickbooksUserVendorTable,
  QuokkaTemplatesInUseSection,
  RentRollTable,
  RequirementsFormContainer,
  RequirementsPanel,
  RequirementsSetIndex,
  ResearchIndex,
  RoyaltySettingsIndex,
  SaleBuyer,
  SendRepEmailButton,
  ShareLink,
  Snackbar,
  StripeAccountSetup,
  StripeCustomerSetup,
  SurveyPropertyForm,
  SwitchAccounts,
  SyndicationBrokerPartnerTable,
  SyndicationTab,
  Tags,
  TasksIndex,
  TemplateTranslations,
  TerritoriesTab,
  TransferRecordsContainer,
  UserProfile,
  VoucherApprovalWorkflowEditor,
  WebhookEventIndex
});

if (module.hot) {
  // Passing a string literal (not a variable, not an array) is the only way HMR works correctly
  module.hot.accept('bundles/assignment/assignment_editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/assignment/components/survey_property_form', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/assignment/index/assignment_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/backoffice/royalty_settings', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept(
    'bundles/backoffice/commission_plans/settings/class_component',
    () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept('bundles/checklist_editor/checklist_editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/apex/settings/class_component', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/comp_reports/form', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/company/configurable_enums/index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/comps/index/comps_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/contact/contact_project_section', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/corporate/corporate_databases', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/contact/index/contact_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/email/option_defaults', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/leads/index/leads_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/pipeline/defaults_editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/plugin/plugin_set_editor/plugin_set_editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/project/project_editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept(
    'components/research/property/contact_info/contact_role_context_menu',
    () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept('bundles/backoffice/deductions/settings', () => {
    ReactOnRails.reactOnRailsPageLoaded();
  });
  module.hot.accept('bundles/tags/tags', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/tasks/associated_tasks', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/tasks/index/call_list_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/tasks/index/tasks_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/tasks/workflows/editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/tasks/mobile_associated_tasks_wrapper', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept(
    'components/documents/access_settings/access_changed_banner',
    () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept('components/tasks/mobile_new_task_form_style_wrapper', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/assignments/assignment_edit_form', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/attachments/panel', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/billing_account/editor', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/call_lists/add_to_call_list_dropdown', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/call_lists/add_to_call_list_link', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/click_to_call/call_contact_link', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/csv_importer/csv_importer', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/database/database_field', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/database/transfer_records_container', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/plugin/pinned_listings', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/webhook_event/index/webhook_event_index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/photos/photo_form', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/property/property_edit_form', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/property/rent_roll/rent_roll_table', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/modals/quokka_template_defaults_modal', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/forwarding_email', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept(
    'bundles/company/document_defaults/document_defaults',
    () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept(
    'bundles/company/document_defaults/doc_template_list',
    () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept('components/contacts/forms/mobile_activity_form_wrapper',
    () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/contacts/contact_preview/contact_preview_container', () => {
    ReactOnRails.reactOnRailsPageLoaded();
  });
  module.hot.accept('bundles/backoffice/vouchers/approval_status/overlay_trigger', () => {
    ReactOnRails.reactOnRailsPageLoaded();
  });
  module.hot.accept('bundles/backoffice/vouchers/approval_workflow', () => ReactOnRails.reactOnRailsPageLoaded());

  module.hot.accept('bundles/plugin/website_section_editor/website_section_editor', () => {
    ReactOnRails.reactOnRailsPageLoaded();
  });
  module.hot.accept('bundles/databases/database_settings/database_tag_manager',
    () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/invoicing_form/index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/requirements_set/index/requirements_set_index', () => {
    ReactOnRails.reactOnRailsPageLoaded();
  });
  module.hot.accept('bundles/shadow_grid/company_grids_settings', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/users/syndication/syndication_tab', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('components/document_editor/downloadable_report_field_selector', () => {
    ReactOnRails.reactOnRailsPageLoaded();
  });
  module.hot.accept('bundles/corporate/parent_company_users/profile', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/company/profile/index', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept('bundles/email_index/property_email_index', () => ReactOnRails.reactOnRailsPageLoaded());
}
